import makeHead from 'components/Table/Head' 

const HomeworksHead = makeHead([
  { id: 'title', align: 'left', disablePadding: false},
  { id: 'start', align: 'left', disablePadding: true},
  { id: 'finish', align: 'left', disablePadding: true},
  { id: 'status', align: 'left', disablePadding: true},
  { id: 'points', align: 'center', disablePadding: true},
  { id: 'availability', align: 'center', disablePadding: true}
],({styles}) => ({...styles}))

export {HomeworksHead as default}

